import { Text } from 'react-stacked'

const ListEmptyComponent: React.FC<{ text: string }> = ({ text }) => (
  <Text align='center' color='black' paddingVertical={50} size={16}>
    {text}
  </Text>
)

export default ListEmptyComponent
